"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Duration = void 0;
const cafe_utility_1 = require("cafe-utility");
class Duration {
    constructor(seconds) {
        this.seconds = Math.ceil(seconds);
        if (seconds < 0) {
            this.seconds = 0;
        }
    }
    static fromMilliseconds(milliseconds) {
        return new Duration(milliseconds / 1000);
    }
    static fromSeconds(seconds) {
        return new Duration(seconds);
    }
    static fromHours(hours) {
        return new Duration(hours * 60 * 60);
    }
    static fromDays(days) {
        return new Duration(days * 24 * 60 * 60);
    }
    static fromWeeks(weeks) {
        return new Duration(weeks * 7 * 24 * 60 * 60);
    }
    static fromYears(years) {
        return new Duration(years * 365 * 24 * 60 * 60);
    }
    static fromEndDate(endDate, startDate) {
        return new Duration((endDate.getTime() - (startDate ?? new Date()).getTime()) / 1000);
    }
    /**
     * Parses a duration string and returns a `Duration` instance.
     *
     * Case insensitive. E.g. both `"28h"` and `"1D"` are valid.
     *
     * Whitespaces are ignored. E.g. both `"5 d"` and `"2weeks"` are valid.
     *
     * Decimal numbers are supported. E.g. `"1.5h"` is valid.
     *
     * Supported units:
     *
     * - ms, milli, millis, millisecond, milliseconds
     * - s, sec, second, seconds
     * - m, min, minute, minutes
     * - h, hour, hours
     * - d, day, days
     * - w, week, weeks
     * - month, months
     * - y, year, years
     *
     * @param duration - A string representing a duration
     * @returns a `Duration` instance
     */
    static parseFromString(duration) {
        return Duration.fromSeconds(cafe_utility_1.Dates.make(duration) / 1000);
    }
    toSeconds() {
        return this.seconds;
    }
    toHours() {
        return this.seconds / 60 / 60;
    }
    toDays() {
        return this.seconds / 24 / 60 / 60;
    }
    toWeeks() {
        return this.seconds / 7 / 24 / 60 / 60;
    }
    toYears() {
        return this.seconds / 365 / 24 / 60 / 60;
    }
    toEndDate(startDate) {
        return new Date((startDate ?? new Date()).getTime() + this.seconds * 1000);
    }
    represent() {
        return cafe_utility_1.Dates.secondsToHumanTime(this.seconds);
    }
    isZero() {
        return this.seconds === 0;
    }
}
exports.Duration = Duration;
Duration.ZERO = new Duration(0);
